document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.wcl-header');

    if ( !header ) return;

    window.addEventListener('scroll', () => {
        if ( window.scrollY > 50 ) {
            header.classList.add('scroll');
        } else {
            header.classList.remove('scroll');
        }
    });
});